import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { assistantroboPageMeta, assistantroboSchema } from 'components/common/schema'
import Template from 'components/cases/assistantrobo'

const Assistantrobo: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...assistantroboPageMeta} />
      <JsonLd data={assistantroboSchema} />
      <Template />
    </>
  )
}

export default Assistantrobo
